import Popup from 'reactjs-popup';
import Select from 'react-select'
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { DesignationDDL } from '../../../../Components/CommonDDL/DesignationDDL';
import { DepartmentDataDDL } from '../../../../Components/CommonDDL/DepartmentDataDDL';
import { useAuthState } from '../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { EmployeePostDataAPI } from '../../../../Redux/SidebarMasterSlice/EmployeeSlice';
import { RegExOnlyText } from '../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../Helper/AstricSign';


export default function EmployeePopup(props) {

    const { handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // const [rowData, setRowData] = useState(item)

    const [IsValidNumbers, setIsValidNumbers] = useState(false)
    const [IsValidEmail, setIsValidEmail] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_DesignationID : 0,
        Label: Flag === 'Update' ? rowData.designationName : "Select...",
    })
    const [Department, setDepartment] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_DepartmentID : 0,
        Label: Flag === 'Update' ? rowData.departmentName : "Select...",

    })
    const [EmployeeName, setEmployeeName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [EmployeeField, setEmployeeField] = useState({
        EmployeeName: Flag === 'Update' ? rowData.employeeName : '',
        MobileNumber: Flag === 'Update' ? rowData.mobileNumber : '',
        EmailID: Flag === 'Update' ? rowData.email_ID : ''
    })

    const handleEmployeeField = (e) => {
        setEmployeeField({ ...EmployeeField, [e.target.name]: e.target.value })
    }

    const [IsOpen, setIsOpen] = useState(false)

    // useEffect(() => {
    //     setEmployeeField({
    //         EmployeeName: Flag === 'Update' ? rowData.employeeName : '',
    //         MobileNumber: Flag === 'Update' ? rowData.mobileNumber : '',
    //         EmailID: Flag === 'Update' ? rowData.email_ID : ''
    //     })
    // }, [item, IsOpen])

    // console.log(Flag, EmployeeField)
    const handleClearField = () => {

        if (Flag != 'Update') {
            setEmployeeField({
                EmployeeName: '',
                MobileNumber: '',
                EmailID: ''
            })
        }
    }

    const [IsValidText, setIsValidText] = useState(false)
    const handleCheckText = (e) => {
        handleEmployeeField(e)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const handleCheckMobileNumber = (e) => {
        handleEmployeeField(e)
        let regex = new RegExp(/^[0-9]*$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidNumbers(false)
        } else {
            setIsValidNumbers(true)
        }
    }

    const handleCheckEmail = (e) => {
        handleEmployeeField(e)
        let regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
        if (regex.test(e.target.value) || e.target.value === "") {
            setIsValidEmail(false)
        } else {
            setIsValidEmail(true)
        }
    }

    const handlePost = () => {
        const data = {
            M_DepartmentID: Department.ID,
            M_EmployeeID: Flag === 'Update' ? rowData.m_EmployeeID : '0',
            M_DesignationID: Designation.ID,
            EmployeeName: EmployeeField.EmployeeName,
            MobileNumber: EmployeeField.MobileNumber,
            Email_ID: EmployeeField.EmailID,
            JoiningDate: '',
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleClearField: handleClearField,
            handleOnCloseClick:handleOnCloseClick
        }
        dispatch(EmployeePostDataAPI({ data }))

    }

    return (
        // <Popup
        //     onOpen={() => setIsOpen(!IsOpen)}
        //     contentStyle={{ top: '5%' }}
        //     trigger={
        //         Flag === 'Update' ?
        //             <i className="fa-solid fa-pen-to-square" style={{ cursor: "pointer" }} title='Edit'></i>
        //             :
        //             <i className="fa-solid fa-plus btn btn-secondary float-end mb-2" style={{ color: "white", marginTop: '-2.5em' }}>
        //                 <text className="ml-2 poppins">Add</text>
        //             </i>
        //     }
        //     modal>



        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl  " >
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Employee</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className="col-12 col-md-6 col-lg-6">
                                    <DesignationDDL
                                        Designation={Designation}
                                        setDesignation={setDesignation}
                                        rowData={rowData}
                                        Flag={Flag}
                                        IsPost={IsPost}
                                    />
                                </div>
                                {/* <div className="col-12 col-lg-6">
                                            <DepartmentDataDDL
                                                Department={Department}
                                                setDepartment={setDepartment}
                                                rowData={rowData}
                                                Flag={Flag}
                                            />
                                        </div> */}
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Employee Name <AstricSign /> </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='EmployeeName'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.EmployeeName}
                                            onChange={(e) => handleEmployeeField(e)}
                                        />
                                        {/* {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        } */}
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Mobile Number </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='MobileNumber'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.MobileNumber}
                                            onChange={handleCheckMobileNumber}
                                            maxLength={10}
                                        />
                                        {
                                            IsValidNumbers && <text style={{ color: 'red' }}>Please Enter valid Mobile Number</text>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Email Id </b></label>
                                        <input type="text" className="form-control" id="exampleInputEmail1" name='EmailID'
                                            aria-describedby="emailHelp"
                                            value={EmployeeField.EmailID}
                                            onChange={handleCheckEmail}
                                        />
                                        {
                                            IsValidEmail && <text style={{ color: 'red' }}>Please Enter valid Email</text>
                                        }
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12  pt-md-4 pt-4">
                                <div className="btn-action d-flex justify-content-end ">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"                                    
                                        onClick={() => handlePost() }
                                        disabled={
                                            Designation.ID == 0 || EmployeeField.EmployeeName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                           
                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}